import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import TextFieldEditor from '../text-field-editor/TextFieldEditor.jsx';
import TextAreaEditor from '../text-area-editor/TextAreaEditor.jsx';

import s from './InfoEditor.module.scss';

const InternalEditor = ({ poi, onUpdatePoiField, disabled }) => (
    <div className={classNames(s.infoEditor)}>
        <div className={s.bannerWrapper}>
            <div className={s.banner}>ATRIUS INTERNAL FIELDS</div>
        </div>
        <div className={s.controlsGrid}>
            <TextFieldEditor
                label="airline code"
                value={poi.airlineCode}
                onChange={value => {
                    onUpdatePoiField('airlineCode', value);
                }}
                disabled={disabled}
            />

            <TextFieldEditor
                label="attributes"
                value={poi.attributes}
                onChange={value => {
                    onUpdatePoiField('attributes', value);
                }}
                disabled={disabled}
            />

            <TextFieldEditor
                label="category search"
                value={poi.categorySearch}
                onChange={value => {
                    onUpdatePoiField('categorySearch', value);
                }}
                disabled={disabled}
            />

            <TextFieldEditor
                label="Map rotation"
                value={poi.rotationProperties}
                onChange={value => {
                    onUpdatePoiField('rotationProperties', value);
                }}
                disabled={disabled}
            />

            <TextAreaEditor
                label="display properties"
                value={poi.displayProperties}
                onChange={value => {
                    onUpdatePoiField('displayProperties', value);
                }}
                disabled={disabled}
            />

            <TextFieldEditor
                label="directions"
                value={poi.noDirections}
                onChange={value => {
                    onUpdatePoiField('noDirections', value);
                }}
                disabled={disabled}
            />

            <TextFieldEditor
                label="url display"
                value={poi.urlDisplay}
                onChange={value => {
                    onUpdatePoiField('urlDisplay', value);
                }}
                disabled={disabled}
            />

            <TextAreaEditor
                label="custom searches"
                value={poi.customSearches}
                onChange={value => {
                    onUpdatePoiField('customSearches', value);
                }}
                disabled={disabled}
            />
        </div>
    </div>
);

InternalEditor.propTypes = {
    disabled: PropTypes.bool,
    onUpdatePoiField: PropTypes.func,
    poi: PropTypes.object,
};

InternalEditor.defaultProps = { disabled: false, onUpdatePoiField: () => {}, poi: {} };

export default InternalEditor;
